'use client';
import { copyJson } from '@dte/otw-utils-core/src/objects/copyJson';
import { atom } from 'jotai';
import { locationAtom } from '../../useUpdateLocationOnReport';

export const locationPremiseIdAtom = atom(
	(get) => {
		// TODO: should we look at report premise id?
		return get(locationAtom)?.premiseId;
	},
	(get, set, value: string) => {
		const location = get(locationAtom);
		const newValue = copyJson(location);
		newValue.premiseId = value;
		set(locationAtom, newValue);
	},
);
locationPremiseIdAtom.debugLabel = 'premiseIdAtom';
